
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blogs/2021-10-15-transition",
      function () {
        return require("private-next-pages/blogs/2021-10-15-transition/index.page.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blogs/2021-10-15-transition"])
      });
    }
  